import { SET_SHEET, CLOSE_SHEET } from './types'

const initialState = {
  sheet: {},
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SHEET:
      return {
        ...state,
        sheet: { ...action.payload },
      }

    case CLOSE_SHEET:
      return {
        ...state,
        sheet: { ...state.sheet, closeSheet: true, isVisible: false },
      }

    default:
      return state
  }
}
export default reducer
